import { useCallback } from 'react';

import { Trans } from 'react-i18next';

import { WEB3AUTH_WALLETS_INFO } from 'app/constants/wallets';
import { useAuthentication } from 'app/hooks/useAuthentication';
import { Web3AuthLoginProvider } from 'app/types/providers';
import { Button } from 'app/shared/buttons/Button';

type Provider = Exclude<Web3AuthLoginProvider, 'email_passwordless'>;

export const LOGIN_PROVIDERS: Provider[] = [
  'google',
  'twitter',
  'apple',
  'discord',
  'reddit',
];

export const SocialConnections = () => {
  const {connect} = useAuthentication();

  const handleProviderClick = useCallback(
    async (provider: Provider) => {
      await connect('web3_auth', false, {
        loginProvider: provider,
      });

      window.safary?.track({
        eventType: 'form',
        eventName: `${provider}-connect`,
      });
    },
    [connect],
  );

  return (
    <div className="flex w-full flex-col items-center justify-center gap-3.75">
      <div className="flex text-sm font-medium leading-normal text-white light:text-neutral-7">
        <Trans i18nKey="connect.connectWithSocialAccount" />
      </div>

      <div className="flex w-full items-center justify-between">
        {LOGIN_PROVIDERS.map(provider => (
          <ProviderButton
            key={provider}
            provider={provider as Provider}
            onClick={handleProviderClick}
          />
        ))}
      </div>
    </div>
  );
};

type ProviderButtonProps = {
  onClick: (provider: Provider) => void;
  provider: Provider;
};

const ProviderButton = ({provider, onClick}: ProviderButtonProps) => {
  const {Icon, name} = WEB3AUTH_WALLETS_INFO[provider];

  const handleClick = useCallback(() => onClick(provider), [onClick, provider]);

  return (
    <Button
      // {...buildEvent('button_login', provider)}
      aria-label={`Connect with ${provider}`}
      onClick={handleClick}
      className="flex h-14 w-14 items-center justify-center rounded-full border-[1px] border-[rgba(229,229,229,0.1)] bg-[#111A24] transition-all hover:scale-[1.05] active:border-neutral-200 mobile:h-10 mobile:w-10">
      {Icon ? <Icon className="h-8 w-8 object-contain" /> : name}
    </Button>
  );
};
